{
  "version": "1.0.0",
  "description": "Hard-cut canonical ID migration. Legacy annex labels (B*-NN) kept only in audit artifacts.",
  "schema_steps": {
    "B1-01": "b1p27-a",
    "B1-03": "b1p27-c",
    "B1-04": "b1p27-d",
    "B1-05": "b1p27-e-i",
    "B1-06": "b1p27-e-ii",
    "B1-07": "b1p27-e-iii",
    "B1-08": "b1p27-e-iv",
    "B1-09": "b1p27-e-v",
    "B1-10": "b1p27-e-vi",
    "B1-11": "b1p27-e-vii",
    "B1-12": "b1p28",
    "B2-01-02-03": "b2p29",
    "B2-01-02-03_C2-01-02-03": "b2p29__c2p47",
    "B3-01-02-03": "b3p32__b3p33",
    "B4-01": "b4p34",
    "B4-01-02": "b4p34",
    "B4-03": "b4p34-public-links",
    "B5-01-02-03-04": "b5p35",
    "B6-01-02-03-04": "b6p36__b6p37",
    "B7-01-02": "b7p38",
    "B7-03-04-05": "b7p39",
    "B7-06": "b7p39-c",
    "B8-01-02-03": "b8p40",
    "B8-01-02-03_C5-01-02-03": "b8p40__c5p59",
    "B8-04": "c5p58",
    "B9-01-02-03": "b9p41",
    "B10-01": "b10p42-a",
    "B10-02": "b10p42-b",
    "B10-03": "b10p42-c",
    "B10-04": "b10p42-d",
    "B11-01-02": "b11p43",
    "C1-01": "c1p46-a",
    "C1-02": "c1p46-b",
    "C1-03": "c1p46-c",
    "C1-04": "c1p46-c-suppliers",
    "C1-05": "c1p46-d",
    "C3-01-02-03-04-05-06": "c3p53",
    "C3-07": "c3p53-e",
    "C3-08-09": "c3p54__c3p55",
    "C4-01": "c4p56-a",
    "C4-02": "c4p56-b",
    "C4-03": "c4p56-c",
    "C4-04": "c4p56-d",
    "C4-05": "c4p57",
    "C6-01-02-03-04-05-06-07-08-09": "c6p61",
    "C7-01-02-03-04-05-06-07-08-09": "c7p62",
    "C8-01-02-03-04-05": "c8p63__c8p64",
    "C9-01": "c9p64"
  },
  "form_step_ids": {
    "b2-01-02-03": "b2p29",
    "b2-01-02-03_c2-01-02-03": "b2p29__c2p47",
    "b3-01-02-03": "b3p32__b3p33",
    "b4-01": "b4p34",
    "b4-01-02": "b4p34",
    "b5-01-02-03-04": "b5p35",
    "b6-01-02-03-04": "b6p36__b6p37",
    "b7-01-02": "b7p38",
    "b7-03-04-05": "b7p39",
    "b8-01-02-03": "b8p40",
    "b8-01-02-03_c5-01-02-03": "b8p40__c5p59",
    "b9-01-02-03": "b9p41",
    "b11-01-02": "b11p43",
    "c3-01-02-03-04-05-06": "c3p53",
    "c3-08-09": "c3p54__c3p55",
    "c6-01-02-03-04-05-06-07-08-09": "c6p61",
    "c7-01-02-03-04-05-06-07-08-09": "c7p62",
    "c8-01-02-03-04-05": "c8p63__c8p64"
  },
  "field_prefixes": [
    [
      "b2_01_02_03_c2_01_02_03_",
      "b2p29__c2p47_"
    ],
    [
      "b8_01_02_03_c5_01_02_03_",
      "b8p40__c5p59_"
    ],
    [
      "c6_01_02_03_04_05_06_07_08_09_",
      "c6p61_"
    ],
    [
      "c3_01_02_03_04_05_06_",
      "c3p53_"
    ],
    [
      "c7_01_02_03_04_05_06_07_08_09_",
      "c7p62_"
    ],
    [
      "c8_01_02_03_04_05_",
      "c8p63__c8p64_"
    ],
    [
      "b3_01_02_03_",
      "b3p32__b3p33_"
    ],
    [
      "b5_01_02_03_04_",
      "b5p35_"
    ],
    [
      "b6_01_02_03_04_",
      "b6p36__b6p37_"
    ],
    [
      "b2_01_02_03_",
      "b2p29_"
    ],
    [
      "b7_03_04_05_",
      "b7p39_"
    ],
    [
      "b7_01_02_",
      "b7p38_"
    ],
    [
      "b9_01_02_03_",
      "b9p41_"
    ],
    [
      "b11_01_02_",
      "b11p43_"
    ],
    [
      "b4_01_02_",
      "b4p34_"
    ],
    [
      "b4_03_",
      "b4p34-public-links_"
    ],
    [
      "b1_01_",
      "b1p27-a_"
    ],
    [
      "b1_03_",
      "b1p27-c_"
    ],
    [
      "b1_04_",
      "b1p27-e_"
    ],
    [
      "b1_05_",
      "b1p27-e-i_"
    ],
    [
      "b1_06_",
      "b1p27-e-ii_"
    ],
    [
      "b1_07_",
      "b1p27-e-iii_"
    ],
    [
      "b1_08_",
      "b1p27-e-iv_"
    ],
    [
      "b1_09_",
      "b1p27-e-v_"
    ],
    [
      "b1_10_",
      "b1p27-e-vi_"
    ],
    [
      "b1_11_",
      "b1p27-e-vii_"
    ],
    [
      "b1_12_",
      "b1p28_"
    ],
    [
      "b2_04_",
      "b2p79-a_"
    ],
    [
      "b2_05_",
      "b2p79-b_"
    ],
    [
      "b2_06_",
      "b2p79-c_"
    ],
    [
      "b7_06_",
      "b7p39-c_"
    ],
    [
      "b8_01_02_03_",
      "b8p40_"
    ],
    [
      "b8_04_",
      "c5p58_"
    ],
    [
      "b10_01_",
      "b10p42-a_"
    ],
    [
      "b10_02_",
      "b10p42-b_"
    ],
    [
      "b10_03_",
      "b10p42-c_"
    ],
    [
      "b10_04_",
      "b10p42-d_"
    ],
    [
      "c1_01_",
      "c1p46-a_"
    ],
    [
      "c1_02_",
      "c1p46-b_"
    ],
    [
      "c1_03_",
      "c1p46-c_"
    ],
    [
      "c1_04_",
      "c1p46-c-suppliers_"
    ],
    [
      "c1_05_",
      "c1p46-d_"
    ],
    [
      "c3_07_",
      "c3p53-e_"
    ],
    [
      "c3_08_09_",
      "c3p54__c3p55_"
    ],
    [
      "c4_01_",
      "c4p56-a_"
    ],
    [
      "c4_02_",
      "c4p56-b_"
    ],
    [
      "c4_03_",
      "c4p56-c_"
    ],
    [
      "c4_04_",
      "c4p56-d_"
    ],
    [
      "c4_05_",
      "c4p57_"
    ],
    [
      "c9_01_",
      "c9p64_"
    ]
  ],
  "datapoints": {
    "b2p29-27-01": "b2p29-a",
    "b2p29-27-02": "b2p29-b",
    "b2p29-27-03": "b2p29-d",
    "b2p29-27": "b2p29",
    "b2-practices": "b2p29-complete",
    "b7-03-hazardous": "b7p39-hazardous-waste-produced",
    "b7-03-non-hazardous": "b7p39-non-hazardous-waste-produced",
    "b7-05-hazardous": "b7p39-recycled-reused-hazardous",
    "b7-05-non-hazardous": "b7p39-recycled-reused-non-hazardous",
    "b7p39-03": "b7p39-hazardous-waste-produced",
    "b7p39-04": "b7p39-non-hazardous-waste-produced",
    "b7p39-05": "b7p39-recycled-reused-total",
    "b7p39-05-hazardous": "b7p39-recycled-reused-hazardous",
    "b7p39-05-non-hazardous": "b7p39-recycled-reused-non-hazardous",
    "b6p37-04": "b6p37-water-stressed-consumption",
    "b9p41-02": "b9p41-work-accident-rate",
    "b9p41-03": "b9p41-work-related-fatalities",
    "b4p34-02": "b4p34-microplastics",
    "b4-01": "b4p34",
    "b11p43-02": "b11p43-corruption-bribery-fines",
    "b11-has-corruption-issues": "b11p43-has-issues",
    "b3p49-53": "b3p49__b3p52",
    "c3p54_c3p55": "c3p54__c3p55",
    "b5p35-02": "b5p35-site-areas",
    "b5p35-03": "b5p35-sensitive-zone-names",
    "b5p35-04": "b5p35-site-characteristics",
    "b7p38-02": "b7p38-circular-economy-details",
    "c5p59-60": "c5p59__c5p60",
    "c5p60-03": "c5p60-temporary-agency-workers",
    "c6p61-09": "c6p61-grievance-mechanism",
    "c8p63-02": "c8p63-tobacco-revenue",
    "c8p63-03": "c8p63-fossil-fuels-revenue",
    "c8p63-04": "c8p63-chemicals-revenue",
    "c7p62-08": "c7p62-value-chain-incidents",
    "c2p47-49": "c2p47",
    "c2p47-49-02": "c2p47-b",
    "c2p47-49-03": "c2p48",
    "c3p54-09": "c3p54__c3p55",
    "c6-02-report": "c6p61-policy-covered-topics"
  },
  "retired_canonical_aliases": {
    "b2p29-27": "b2p29",
    "b2p29-27-01": "b2p29-a",
    "b2p29-27-02": "b2p29-b",
    "b2p29-27-03": "b2p29-d",
    "b1p27-e-05": "b1p27-e-i",
    "b1p27-e-06": "b1p27-e-ii",
    "b1p27-e-07": "b1p27-e-iii",
    "b1p27-e-08": "b1p27-e-iv",
    "b1p27-e-09": "b1p27-e-v",
    "b1p27-e-10": "b1p27-e-vi",
    "b1p27-e-11": "b1p27-e-vii"
  }
}
